var ReactSidebarClient =
webpackJsonpReactSidebarClient([1],{

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _propertiesSidebar = __webpack_require__(170);

var _propertiesSidebar2 = _interopRequireDefault(_propertiesSidebar);

__webpack_require__(404);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _propertiesSidebar2.default; /**
                                               * Created by kutenai on 6/21/17.
                                               */

// Make sure we get all items, i.e. the styles

/***/ })

},[169]);


// WEBPACK FOOTER //
// sidebar.js